module.exports = __webpack_public_path__ + "img/video-play.19c2215b.svg";